

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Fab, Grid, Paper, Skeleton, Typography } from '@mui/material'


import OverallWellnessScore from "../personalreport/OverallWellnessScore";

//import KeyAreaNavBar from "./partials/personalreport/KeyAreaNavBar";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

import { useReactToPrint } from "react-to-print";



import HealthAge from "../personalreport/HealthAge";
import Information from "../personalreport/Information";


const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}
const InformationSingle = (props) => {
    const { component } = props
    const { settings, PrintView } = props.otherprops
    const compSize =  parseInt(component.Size) 

    const showName = settings.OrganizationSettingValues['HIDE PARTICIPANT NAME']
    const showNameFlag = (showName === '0' || showName === 0) ? true : false


    const { FirstCalculatedDate
        , FirstCalculatedDateText
        , FirstName
        , LastName
        , MostRecentCalc
        , MostRecentCalcText
        , NameText
        , ResponseCreateDate
        , ResponseCreateDateText
        , AssessmentText } = component
    return (

                        <Box sx={{}}>
                            <Typography variant="body1" fontWeight="bold" style={{ textAlign: 'center', fontSize: "20px" }}>
                                {AssessmentText}
                            </Typography>
                            <Box>
                                <Grid container direction="row" spacing={1} sx={{ paddingTop: "24px" }}>
                                    {showNameFlag && (

                                        <Grid item xs={3}>
                                            <Typography variant="subtitle2" align="left">{NameText}</Typography>
                                        </Grid>
                                    )}
                                    {showNameFlag && (

                                        <Grid item xs={9}>
                                            <Typography variant="body2" align="left">{FirstName} {LastName}</Typography>
                                        </Grid>
                                    )}
                                    <Grid item xs={3}>
                                        <Typography variant="subtitle2" align="left">{ResponseCreateDateText}</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <Typography variant="body2" align="left">{ResponseCreateDate}</Typography>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Typography variant="subtitle2" align="left">{FirstCalculatedDateText}</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <Typography variant="body2" align="left">{FirstCalculatedDate}</Typography>
                                    </Grid>

                                    <Grid item xs={3}>
                                        <Typography variant="subtitle2" align="left">{MostRecentCalcText}</Typography>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <Typography variant="body2" align="left">{MostRecentCalc}</Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>


    )

}

export default InformationSingle